import { globalFormFieldApi } from "api/GlobalFormField/api";
import { useQueryApi } from "api/hooks";

import GetGlobalFormFieldsRequest = App.Http.Requests.GlobalFormField.GetGlobalFormFieldsRequest;
import GetGlobalFormFieldsResponse = App.Http.Responses.GlobalFormField.GetGlobalFormFieldsResponse;

export const useGetGlobalFormFieldsQuery = (request: GetGlobalFormFieldsRequest, options = {}) => {
    return useQueryApi<GetGlobalFormFieldsResponse>({
        queryKey: ["getGlobalFormFields", request],
        queryFn: () => globalFormFieldApi.index(request),
        ...options,
    });
};
